<template>
    <div class="equiDetail"> 
        <div class="equitable">
          <div class="equiImg">
            <img :src="imgsrc" alt="铣刨机"/>
          </div>
          <div class="equiMid">
            <div class="equiMid_top">
                <div class="equiName">{{EquipObj.name}}</div>
                <div class="workStatus_1" v-if="EquipObj.workStatus=='0'">离线</div>
                <div class="workStatus_2" v-if="EquipObj.workStatus=='1'">怠速</div>
                <div class="workStatus_3" v-if="EquipObj.workStatus=='2'">作业中</div>
                <div class="warn" v-if="EquipObj.hasMaintenanceWarning==true">待保养</div>
                <!-- <template v-for="(item,index) in EquipObj.warning">
                  <div v-if="EquipObj.warning.length" class="warn el-icon-warning-outline" :key="index">
                    {{item.cnName}}
                  </div>
                </template> -->
            </div>
            <div class="equiMid_bottom">
                <div class="blockItem">
                  <div class="item_type1">
                    <div class="itemLeft">设备编号</div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.code==null?'':EquipObj.code}}</span>
                    </div>
                  </div>
                  <div class="item_type1">
                    <div class="itemLeft">设备类型</div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.typeName==null?'':EquipObj.typeName}}</span>
                    </div>
                  </div>
                  <div class="item_type2">
                    <div class="itemLeft">所属组织</div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.officeName==null?'':EquipObj.officeName}}</span>
                    </div>
                  </div>
                  
                </div>
                <div class="blockItem">
                  <div class="item_type1">
                    <div class="itemLeft">设备型号</div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.model==null?'':EquipObj.model}}</span>
                    </div>
                  </div>
                  <div class="item_type1">
                    <div class="itemLeft">品牌</div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.brand==null?'':EquipObj.brand}}</span>
                    </div>
                  </div>
                  <div class="item_type1">
                    <div class="itemLeft">铣刨宽度</div>
                    <div class="itemRight">
                      <span  class="infoShow">{{ EquipObj.millingWidth==0||EquipObj.millingWidth==null||EquipObj.millingWidth==''?'--':EquipObj.millingWidth+' mm' }}</span>
                    </div>
                  </div>
                  <div class="item_type1">
                    <div class="itemLeft1">目标日均工作时长</div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.targetDuration==null?'--':EquipObj.targetDuration}} H</span>
                    </div>
                  </div>
                </div>
                <div class="blockItem">
                  <div class="item_type1">
                    <div class="itemLeft">最新位置<i class="el-icon-location-outline" @click="goPosition"></i></div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.currentLocation==null?'':EquipObj.currentLocation}}</span>
                    </div>
                  </div>
                  <div class="item_type1">
                    <div class="itemLeft">最近上线记录</div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.latestOnline==null?'':EquipObj.latestOnline}}</span>
                    </div>
                  </div>
                  <div class="item_type1">
                    <div class="itemLeft">设备负责人</div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.leader==null?'':EquipObj.leader}}</span>
                    </div>
                  </div>
                  <div class="item_type1">
                    <div class="itemLeft1">设备联系电话</div>
                    <div class="itemRight">
                      <span class="infoShow">{{EquipObj.phone==null?'':EquipObj.phone}}</span>
                    </div>
                  </div>
                  
                </div>
                
              
            </div>
          </div>
          <div class="equiRight">
            <div class="equiRight_top"  v-if="riskStatus==0" @click="riskControl">
              <span class="riskStatus_1" v-if="riskStatus==0">{{EquipObj.riskManagement}}</span>
              <span class="risk">风险控制</span>
            </div>
            
            <div class="equiRight_bottom" @click="healthControl">
              <span class="healthStatus_1" v-if="healthStatus==0">{{EquipObj.healthIndex}}</span>
              <span class="health">健康指数</span>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                imgsrc:require("../../../images/all/u4363.png"),
                riskStatus:0,
                healthStatus:0,
            }
        },
        props:["EquipObj"],
        computed: {},
        created() {},
        mounted() {
        },
        components:{},
        methods:{
          riskControl(){
            this.$message({
              message:'该功能暂未开放！',
              type:'info'
            })
          },
          healthControl(){
            this.$message({
              message:'该功能暂未开放！',
              type:'info'
            })
          },
          //前往位置监控
          goPosition(){
            this.$router.push({name:'EquipmentMonitor',params:{equipcode:this.EquipObj.code}})
          }
        },
       
    }
    
</script>
<style lang="scss" scoped="">
    .equiDetail {
    width: 100%;
    height: 242px;
    display: flex;
     .equitable{
        display: flex;
        width: 1768px;
        height: 242px;
        margin-left:12px;
        margin-right:11px;
        background: #FFFFFF;
        border: 1px solid #E4E7ED;
        justify-content:space-between;
        .equiImg{
          width: 244px;
          height: 242px;
          img{
            width: 200px;
            height: 91px; 
            transform: translateX(22px) translateY(75px);
          }
        }
        .equiMid{
          width: 1320px;
          display: flex;
          flex-direction: column;
          .equiMid_top{
            height: 56px;
            display: flex;
            align-items: center;
            .equiName{
              // width: 96px;
              height: 20px;
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #222222;
              line-height: 20px;
              margin-right: 10px;
            }
            .workStatus_1{
              width: 46px;
              height: 22px;
              background: #F2F2F5;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #9A9A9A;
              line-height: 22px;
              text-align: center;
            }
            .workStatus_2{
              width: 46px;
              height: 22px;
              background: #DEF0E5;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #10BE62;
              line-height: 22px;
              text-align: center;
            }
            .workStatus_3{
              width: 56px;
              height: 22px;
              background: #E1EBFA;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #2273F8;
              line-height: 22px;
              text-align: center;
            }
            .workStatus_4{
              width: 56px;
              height: 22px;
              background: #FEEBE8;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #E96C5A;
              line-height: 22px;
              text-align: center;
            }
            .warn{
              // width: 90px;
              height: 22px;
              background: #FF9900;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 22px;
              margin-left: 10px;
              margin-right: 10px;
              text-align: center;
              padding: 0 8px;
            }
          }
          .equiMid_bottom{
            display: flex;
            flex-direction: column;
            border-top: 1px solid rgba(225, 225, 225, 1);
            border-left: 1px solid rgba(225, 225, 225, 1);
            .blockItem {
              display: flex;
              height: 41px;
              .item_type1 {
                flex: 1;
              }
              .item_type2 {
                flex: 2;
              }
              .itemLeft {
                width: 100px;
                height: 40px;
                float: left;
                background: rgba(242, 242, 245, 1);
                border-bottom: 1px solid rgba(225, 225, 225, 1);
                border-right: 1px solid rgba(225, 225, 225, 1);
                line-height: 40px;
                padding-left: 10px;
                color: #555555;
                font-size: 14px;
              }
              .itemLeft1 {
                width: 152px;
                height: 40px;
                float: left;
                background: rgba(242, 242, 245, 1);
                border-bottom: 1px solid rgba(225, 225, 225, 1);
                border-right: 1px solid rgba(225, 225, 225, 1);
                line-height: 40px;
                padding-left: 10px;
                color: #555555;
                font-size: 14px;
              }
              .itemRight {
                // width: 100%;
                height: 40px;
                line-height: 40px;
                padding-left: 18px;
                color: #555555;
                font-size: 14px;

                overflow: hidden;
                border-bottom: 1px solid rgba(225, 225, 225, 1);
                border-right: 1px solid rgba(225, 225, 225, 1);
                .infoShow {
                  width: 100%;
                  height: 100%;
                  border: 0;
                  color: #555555;
                  font-size: 14px;
                }
              }
            }
          }
        }
        .equiRight{
          width: 208px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .equiRight_top{
            width: 178px;
            height: 90px;
            border-radius: 3px;  
            margin-bottom: 16px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #4FACFA;
            line-height: 18px;
            background: #DFECF7;
            display: flex;
            flex-direction: column;
            align-items: center;
            -webkit-user-select: none;
            cursor: pointer;
            .riskStatus_1{
              font-size: 42px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #3193E6;
              line-height: 62px;
            }
            .riskStatus_2{
              display: block;
              background: #DFECF7;
              font-size: 42px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #3193E6;
              line-height: 62px;
            }
            .riskStatus_3{
              display: block;
              background: #DFECF7;
              font-size: 42px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #3193E6;
              line-height: 62px;
            }
            .riskStatus_4{
              display: block;
              background: #DFECF7;
              font-size: 42px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #3193E6;
              line-height: 62px;
            }
          }
          .equiRight_bottom{
            width: 178px;
            height: 90px;
            border-radius: 3px;  
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #8AA316;
            line-height: 18px;
            background: #E6EAD3;
            display: flex;
            flex-direction: column;
            align-items: center;
            -webkit-user-select: none;
            cursor: pointer;
            .healthStatus_1{
              font-size: 42px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #8AA316;
              line-height: 62px;
            }
            .healthStatus_2{
              display: block;
              background: #DFECF7;
              font-size: 42px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #3193E6;
              line-height: 62px;
            }
            .healthStatus_3{
              display: block;
              background: #DFECF7;
              font-size: 42px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #3193E6;
              line-height: 62px;
            }
            .healthStatus_4{
              display: block;
              background: #DFECF7;
              font-size: 42px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #3193E6;
              line-height: 62px;
            }
          }
        }
      } 
    }
</style>